"use client";

import React, { useEffect, useState } from 'react'
import '../styles/home.css'
import NavBar from '../components/NavBar';
import profilepicture from '../photos/profilepicture.jpg'
import coloured from '../photos/profilepicture.png'
import skills from '../utils/skills.js'
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from 'react-responsive-carousel';
import Foot from '../components/Foot.js';
import { MdToggleOff, MdToggleOn, MdWork } from 'react-icons/md';
import { TbBriefcase2Filled, TbSchool } from 'react-icons/tb';
import { FaGraduationCap } from 'react-icons/fa';
import { BsFillBriefcaseFill } from 'react-icons/bs';
import { motion } from "motion/react"
import { Link } from 'react-router-dom';
import GlareHover from '../components/extra/GlareHover.js';
import button from '../audio/button.mp3'
import home from '../audio/home.mp3'
import SplitText from '../components/extra/TextPressure';


const containerVariants = {
  hidden: { opacity: 0 },
  show: {
    opacity: 1,

    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.2,
    },
  },
};

const itemVariants = {
  hidden: { y: 50, x: -300, opacity: 0 },
  show: {
    y: 0,
    x: 0,
    opacity: 1,
    transition: {
      type: 'spring',
      stiffness: 300,
      damping: 20,
      bounce: 0.4,
    },
  },
};


function Home() {
  const [fw, setFw] = useState([...skills.frontend_web])
  const [bw, setBw] = useState([...skills.backend_web])
  const [app, setApp] = useState([...skills.app])
  const [ot, setOt] = useState([...skills.Others])
  const [tech, setTech] = useState(skills.tech)
  const [soft, setSoft] = useState(skills.soft)
  const [skill, setSkill] = useState(false)



  const animat = () => {
    let elem = document.getElementsByClassName("skillbar");

    let i, j;
    for (i = 0, j = elem.length; i < j; i++) {

      let el = elem[i].getElementsByClassName('skillbar-bar')
      let attr = elem[i].getAttribute('data-percent');
      el[0].style['width'] = attr;



    }
  }
  useEffect(() => {
    setFw(skills.frontend_web)
    setBw(skills.backend_web)
    setOt(skills.Others)
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          animat();
          observer.disconnect(); // Remove observer after one-time animation
        }
      });
    });

    document.querySelectorAll(".skillbar").forEach(el => observer.observe(el));
  }, [skill])
  const data = {
    experience: [
      { role: "Intern Intermediate Web Developer", company: "GAO Tek, TechNinja, ATODTECH", year: "2025" },
      { role: "Intern Intermediate Fullstack Developer", company: "ATOD team, Pixel Freelancer", year: "2022 - Present" },
      { role: "Contract Intermediate Fullstack Developer", company: "Distributed", year: "2023 - Present" },
      { role: "Freelance Intermediate Fullstack Web Developer", company: "Freelance Marketplaces", year: "2023 - Present" },
      { role: "Freelance Junior Fullstack Web Developer", company: "Fiverr, Upwork", year: "2022 - 2023" },
      { role: "Freelance Junior Frontend Web Developer", company: "Fiverr", year: "2021 - 2022" },
      { role: "Founded Farmang", company: "Farmang", year: "2025 to present" },
      { role: "Intermediate Software Developer", company: "Sort Inc.", year: "2025 to present" },
    ],
    education: [
      { degree: "Bachelors Degree", institution: "Usmanu Danfodiyo University Sokoto", year: "2017 - 2024" },
      { degree: "Fullstack Open", institution: "University of Helsiniki", year: "2024-2025" },
    ],
  };

  const ExpEd = ({ product, index }) => {
    return (
      <motion.div initial={{ x: index % 2 === 0 ? -150 : 150, opacity: 0 }} whileInView={{ x: 0, opacity: 1 }}  viewport={{ amount: 0.2}}  whileHover={{y:-10, duration:0.9, delay:0}} transition={{ duration: 0.2 }} className="exped">
             <GlareHover
    glareColor="#ffffff"
    glareOpacity={0.3}
    glareAngle={-30}
    glareSize={300}
    transitionDuration={800}
    playOnce={false}
  >
    
        <div className="exped_top">{product.role || product.degree}</div>
        <div className="exped_mid">{product.year}</div>
        <div className="exped_bottom">{product.company || product.institution}</div>
        {product.degree && <FaGraduationCap className='exped_icon' />} {product.role && <TbBriefcase2Filled className='exped_icon' />}</GlareHover>
      </motion.div>
    )
  }

  const EdSec = ({ product }) => {


    return (
      <div className="exped">
        {product.degree}
        {product.year}
        {product.institution}
      </div>
    )
  }
 const [hasMounted, setHasMounted] = useState(false);

  // This useEffect will only run once on the client-side after the initial render
  useEffect(() => {
    setHasMounted(true);
  }, []);
    const handleAnimationComplete = () => {
  console.log('All letters have animated!');
};

// useEffect(()=>{
// document.getElementById("toggle").addEventListener("change", function (e) {
//   e.preventDefault();
//   if (e.target.checked) {
//     document.getElementById("toggle-div").classList.add("night");
//   } else {
//     document.getElementById("toggle-div").classList.remove("night");
//   }
// });
// },[])

const audio = new Audio(button);
const soundEffect=()=>{
    audio.play().catch(function (error) {
    console.log("Sound error")});
}

  return (
    <div className='home'>
     
        <motion.div style={{width:'100%'}}  initial={{ x: 300, opacity: 0 }} whileInView={{ x: 0, opacity: 1 }} transition={{ duration: 0.3, delay: 0 }} viewport={{ amount: 0, once: true }} >
      <motion.div initial={{ y: 200, opacity: 0 }} whileInView={{ y: 0, opacity: 1 }} transition={{ duration: 0.2, delay: 0.3 }} viewport={{ amount: 0, once: true }} className="home_top">
 


     <div className="ht_left">
          <span>I am<h1>&nbsp;Shu'aib N. Olawale</h1>,</span>
          <span>a<h1>&nbsp; Full-stack Developer</h1>.</span>
          <article>
            <div className="article_left">
              A seasoned virtuoso of full-stack development, honing my frontend and backend development skills across the span of 5 years, in order to build modern responsive web apps with exceptional digital experience.</div>
            {/* <div className="article_right">Blends advanced technical expertise with exceptional interpersonal skills, fostering effective teamwork and innovative problem-solving. Adaptable and detail-oriented, excelling in both technical and non-technical domains.</div> */}
          </article>
          
          <Link style={{ width: "100%", margin: '0' }} to='/contact'><motion.button initial={{ opacity: 0 }}
            animate={{
              opacity: 1,
              rotate: [0, -15, 15, -15, 15, -15, 15, -15, 15,-15, 15, 0]
            }}
            transition={{
              duration: 1.5,
              ease: "easeInOut",
              delay: 0.6,
              type: "tween"
            }} style={{ height: '50px' }} onClick={soundEffect} className="fx-4 cc-2-1" type='submit'>HIRE ME / SAY HI</motion.button></Link>
        </div>
        <div className="ht_right">
          <img src={coloured} alt="" />
        </div>
      </motion.div>
      <span style={{ display: "flex", width: "100%", maxWidth: '1200px', marginBottom: '20px', marginTop: '50px', padding: '15px', paddingBottom: '0px' }} className="home_mid-topmost">
        <div className="home_mid_head">
          Skills
        </div>
        <span onClick={() => setSkill(!skill)} className="home_mid-toggle">{skill ? <MdToggleOn className='home_toggle-icon' /> : <MdToggleOff className='home_toggle-icon' />}</span>
      </span>

      {
        skill ? <div className="home_mid">

          <Carousel showArrows={false} useKeyboardArrows={true} emulateTouch={true} preventMovementUntilSwipeScrollTolerance={true} swipeScrollTolerance={50}
            swipeable={true} showThumbs={false} style={{ height: '100%', overflow: "auto" }}>

            <div className="home_mid-sec">
                         <SplitText
  text="Frontend Development"
  className="split-parent"
  delay={100}
  duration={0.6}
  ease="power3.out"
  splitType="chars"
  from={{ opacity: 0, y: 40 }}
  to={{ opacity: 1, y: 0 }}
  threshold={0.1}
  rootMargin="10px"
  textAlign="center"
  onLetterAnimationComplete={handleAnimationComplete}
/> 
              {
                fw.map((data, index) => {
                  return <div key={index} id='skillbar' className="skillbar clearfix " data-percent={data[1]}>
                    <div className="skillbar-title" style={{ background: "#970cc1" }}><span>{data[0]}</span></div>
                    <div className="skillbar-bar one"></div>
                    <div className="skill-bar-percent">{data[1]}</div>
                  </div>
                })
              }
            </div>
            {/* <div className="home_mid-sec">
            <h1>Mobile App Development</h1>
            {
              app.map((data) => {
                return <div id='skillbar' className="skillbar clearfix " data-percent={data[1]}>
                  <div className="skillbar-title" style={{ background: "#970cc1" }}>{data[0]}</div>
                  <div className="skillbar-bar one"></div>
                  <div className="skill-bar-percent">{data[1]}</div>
                </div>
              })
            }
          </div> */}
            <div className="home_mid-sec">
                                       <SplitText
  text="Backend Development"
  className="split-parent"
  delay={100}
  duration={0.6}
  ease="power3.out"
  splitType="chars"
  from={{ opacity: 0, y: 40 }}
  to={{ opacity: 1, y: 0 }}
  threshold={0.1}
  rootMargin="10px"
  textAlign="center"
  onLetterAnimationComplete={handleAnimationComplete}
/> 
              {
                bw.map((data, index) => {
                  return <div key={index} id='skillbar' className="skillbar clearfix " data-percent={data[1]}>
                    <div className="skillbar-title" style={{ background: "#970cc1" }}><span>{data[0]}</span></div>
                    <div className="skillbar-bar one"></div>
                    <div className="skill-bar-percent">{data[1]}</div>
                  </div>
                })
              }
            </div>
            <div className="home_mid-sec">
                                       <SplitText
  text="Others"
  className="split-parent"
  delay={100}
  duration={0.6}
  ease="power3.out"
  splitType="chars"
  from={{ opacity: 0, y: 40 }}
  to={{ opacity: 1, y: 0 }}
  threshold={0.1}
  rootMargin="10px"
  textAlign="center"
  onLetterAnimationComplete={handleAnimationComplete}
/> 
              {
                ot.map((data, index) => {
                  return <div key={index} id='skillbar' className="skillbar clearfix " data-percent={data[1]}>
                    <div className="skillbar-title" style={{ background: "#970cc1" }}><span>{data[0]}</span></div>
                    <div className="skillbar-bar one"></div>
                    <div className="skill-bar-percent">{data[1]}</div>
                  </div>
                })
              }
            </div>
          </Carousel>
        </div> :
          <div className="home_center">

            <div className="home_center_up">                  <SplitText
  text="Technical Skills"
  className="split-parent home_center_header"
  delay={100}
  duration={0.6}
  ease="power3.out"
  splitType="chars"
  from={{ opacity: 0, y: 40 }}
  to={{ opacity: 1, y: 0 }}
  threshold={0.1}
  rootMargin="10px"
  textAlign="start"
  onLetterAnimationComplete={handleAnimationComplete}
/>
              <div className="home_center_body">
                {tech.map((res, index) => {
                  return <span key={index}>{res.icon} {res.name}</span>
                })}
              </div>
            </div>
            <div className="home_center_down">
                   <SplitText
  text="Soft Skills"
  className="split-parent home_center_header"
  delay={100}
  duration={0.6}
  ease="power3.out"
  splitType="chars"
  from={{ opacity: 0, y: 40 }}
  to={{ opacity: 1, y: 0 }}
  threshold={0.1}
  rootMargin="10px"
  textAlign="start"
  onLetterAnimationComplete={handleAnimationComplete}
/>
              <div className="home_center_body">
                {soft.map((res, index) => {
                  return <span key={index}>{res.icon} {res.name}</span>
                })}
              </div>
            </div>
          </div>
      }

      <div className="home_bottom">
        <div className="home_bottom-up">Experience and Education</div>
        <div className="experience-education-section">
          {[data.experience[7], data.education[1], data.experience[0], data.experience[6], data.education[0], data.experience[2], data.experience[3], data.experience[4], data.experience[5]]
            .map((item, index) => (
              <div className={`card-wrapper ${index % 2 === 0 ? 'left' : 'right'}`} key={index}>
                <ExpEd product={item} index={index} />

              </div>
            ))}
        </div>
      </div>
      </motion.div>
      <div className="home_foot"><Foot /></div>
    </div >
  )
}

export default Home
